module.exports = __webpack_public_path__ + "static/img/logo_39.f22df8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_39.png
// module id = 1xU9
// module chunks = 1